/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Caption_LineInputs */

const en_hero_caption_line = /** @type {(inputs: Hero_Caption_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every collection starts as one line.`)
};

/**
* | output |
* | --- |
* | "Every collection starts as one line." |
*
* @param {Hero_Caption_LineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hero_caption_line = /** @type {((inputs?: Hero_Caption_LineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Caption_LineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hero_caption_line(inputs)
});